import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 6.313a4.813 4.813 0 1 1 0 9.625 4.813 4.813 0 0 1 0-9.625M17.25 5H19v1.75a.875.875 0 0 0 1.75 0V5h1.75a.875.875 0 1 0 0-1.75h-1.75V1.5a.875.875 0 0 0-1.75 0v1.75h-1.75a.875.875 0 1 0 0 1.75m4.983 4.48a.875.875 0 0 0-.727 1q.12.755.119 1.52a9.59 9.59 0 0 1-2.433 6.389 8.7 8.7 0 0 0-2.672-2.513 6.545 6.545 0 0 1-9.04 0 8.7 8.7 0 0 0-2.672 2.513A9.62 9.62 0 0 1 12 2.375q.765 0 1.52.12a.875.875 0 1 0 .273-1.73A11.384 11.384 0 0 0 .625 12a11.35 11.35 0 0 0 3.699 8.387 1 1 0 0 0 .145.13 11.35 11.35 0 0 0 15.062 0 1 1 0 0 0 .144-.13 11.35 11.35 0 0 0 3.7-8.387q0-.902-.14-1.793a.874.874 0 0 0-1.002-.727"
    }, null, -1)
  ])))
}
export default { render: render }